import React from 'react';

const Footer = () => {
    return (
        <div className="bg-secondary text-center text-white mt-3 py-2">
            IARC-2023
        </div>
    );
};

export default Footer;